import * as React from 'react';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../../../../../../../Hooks/useFullscreenView';
import { SchedulerContext } from '../../SchedulerContext';
import { useContext } from 'react';
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import { IRoutineAvailability } from '../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import EDIconButton from '../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import {
  hasRutinKod,
  isReadOnlyRutin,
} from '../../../../../ObjektVyer/Aktivitet/Utils/AktivitetUtils';
import { IBookingType } from './AppointmentComponent';
import EDTooltip from '../../../../../../../../BaseComponents/Tooltip/EDTooltip';

interface IAppointmentModel {
  /** The start date. */
  startDate: Date | number | string;
  /** The end date. */
  endDate?: Date | number | string;
  /** The title. */
  title?: string;
  /** The all day flag. */
  allDay?: boolean;
  /** The identifier. */
  id?: number | string;
  /** Specifies the appointment recurrence rule. */
  rRule?: string | undefined;
  /** Specifies dates excluded from recurrence. */
  exDate?: string | undefined;
  /** Any other properties. */
  [propertyName: string]: any;
}

interface IHeaderProps {
  /** The appointment’s displayed metadata. */
  appointmentData?: IAppointmentModel;
  /** Specifies the Open button’s visibility. */
  showOpenButton: boolean;
  /** Specifies the Close button’s visibility. */
  showCloseButton: boolean;
  /** Specifies the Delete button’s visibility. */
  showDeleteButton: boolean;
  /** An event raised when the Open button is clicked. The event handler should open the appointment form. */
  onOpenButtonClick?: () => void;

  canEditBooking: boolean;

  availableRoutines: IRoutineAvailability | undefined;

  onClose?: () => void;

  data: IBookingType;
}

export const CustomTooltipHeaderComponent = (props: IHeaderProps) => {
  const schedulerContext = useContext(SchedulerContext);
  const isSmallScreen = useIsSmallScreen();
  const isExtraSmallScreen = useIsExtraSmallScreen();

  const mouseLeave = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (!props?.appointmentData?.mooreBookings) {
      if (!isSmallScreen || !isExtraSmallScreen) {
        const relatedTarget = e?.relatedTarget as HTMLElement | null;
        if (
          relatedTarget?.className &&
          typeof relatedTarget?.className === 'string'
        ) {
          if (relatedTarget?.className?.startsWith('MuiBackdrop-root')) {
            schedulerContext.tooltipOnHover(true);
          }
        }
      }
    }
  };
  return (
    <EDBox
      style={{
        height: '1px',
        backgroundColor: 'white',
      }}
      onMouseLeave={mouseLeave}
      data-testid="headerHover"
    >
      {(props.canEditBooking &&
        hasRutinKod('rtnWebKalender', props.availableRoutines) &&
        !isReadOnlyRutin('rtnWebKalender', props.availableRoutines) &&
        props.data?.aktivityType === 'AKTOVRIGT') ||
      (props.canEditBooking &&
        hasRutinKod('rtnWebBokaGudstjanst', props.availableRoutines) &&
        !isReadOnlyRutin('rtnWebBokaGudstjanst', props.availableRoutines) &&
        hasRutinKod('rtnWebKalender', props.availableRoutines) &&
        !isReadOnlyRutin('rtnWebKalender', props.availableRoutines) &&
        props.data?.aktivityType === 'GUDSTJANST') ? (
        <EDBox>
          <EDTooltip title={'Redigera'} placement="bottom">
            <EDIconButton
              sx={{
                padding: isSmallScreen ? '0px' : '8px',
                marginRight: isSmallScreen ? '0px' : '8px',
                position: 'absolute',
                top: 8,
                right: isSmallScreen ? 50 : 8,
              }}
              icon={'edit'}
              tooltip={''}
              onClick={() => {
                props.onOpenButtonClick?.();
              }}
              iconSize={isSmallScreen ? 'medium' : 'default'}
              testId="activityHeaderIcon"
            ></EDIconButton>
          </EDTooltip>
          {isSmallScreen && (
            <EDTooltip title={'Stäng'} placement="bottom">
              <EDIconButton
                icon={'close'}
                tooltip={''}
                onClick={props.onClose}
                iconSize={isSmallScreen ? 'medium' : 'default'}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: isSmallScreen ? 0 : undefined,
                }}
                testId="activityHeaderCloseIcon"
              ></EDIconButton>
            </EDTooltip>
          )}
        </EDBox>
      ) : (
        <EDBox sx={{ position: 'relative' }}>
          {props.data?.aktivityType !== 'OUTLOOK' && (
            <EDTooltip title={'Öppna'} placement="bottom">
              <EDIconButton
                sx={{
                  padding: isSmallScreen ? '0px' : '8px',
                  position: 'absolute',
                  top: 0,
                  right: 30,
                }}
                icon={'info'}
                tooltip={''}
                onClick={() => {
                  props.onOpenButtonClick?.();
                }}
                iconSize={isSmallScreen ? 'medium' : 'default'}
                testId="activityHeaderIcon"
              ></EDIconButton>
            </EDTooltip>
          )}
          {isSmallScreen && (
            <EDTooltip title={'Stäng'} placement="bottom">
              <EDIconButton
                sx={{
                  padding: '0px',
                  position: 'absolute',
                  top: 0,
                  right: 0,
                }}
                icon={'close'}
                tooltip={''}
                onClick={props.onClose}
                iconSize={isSmallScreen ? 'medium' : 'default'}
                testId="activityHeaderCloseIcon"
              ></EDIconButton>
            </EDTooltip>
          )}
        </EDBox>
      )}
    </EDBox>
  );
};
